import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import classNames from 'classnames'

import {
    requestShopGoods,
    requestRewards,
    purchaseItem,
    makeRewardAuctionBet,
    cancelRewardAuctionBet,
    requestPreloadImages,
    setShopInnerPageState,
} from 'state/actions/wgcwx_shop'
import { requestComparisonStatus } from 'state/actions/comparison_basket'
import { requestBalance } from 'state/actions/balance'

import { Processing } from 'react-wot-bootstrap'
import WGCWXConfirmation from 'components/WGCWXConfirmation/WGCWXConfirmation'
import WGCWXShopProducts from './containers/WGCWXShopProducts/WGCWXShopProducts'
import WGCWXShopDetailedProduct from './containers/WGCWXShopDetailedProduct/WGCWXShopDetailedProduct'
import WGCWXRewards from './containers/WGCWXRewards/WGCWXRewads'
import WGCWXRewardsTank from './containers/WGCWXRewardsTank/WGCWXRewardsTank'

import { CLAN_LANDING } from 'urls'
import {
    PARTITION_TYPES,
    REWARDS_TYPES,
} from './constants'
import ERRORS, { ERROR_CODES, ERROR_TITLES, ERROR_ACTION_TYPES } from './errors'

import { AFFIRMATIVE } from './translations'

import {
    ProductPropTypes,
    RewardPropTypes,
    RewardsMetaPropTypes,
    BalancePropTypes,
} from './propTypes'

import { playExitClansWinnerRewardSound, playEnterClansWinnerRewardSound } from 'state/actions/sounds'

import { addWOTClientListener, C2W_EVENT_TYPES, removeWOTClientListener } from '@wotfe/client2web'

import styles from './WGCWXShop.scss'

export class WGCWXShop extends React.Component {
    static propTypes = {
        partitionType: PropTypes.string.isRequired,
        loading: PropTypes.bool.isRequired,
        error: PropTypes.string,
        productsErrorActionType: PropTypes.oneOf(Object.values(ERROR_ACTION_TYPES)),
        rewardsErrorActionType: PropTypes.oneOf(Object.values(ERROR_ACTION_TYPES)),
        products: PropTypes.objectOf(ProductPropTypes),
        accountInfo: PropTypes.shape({
            fame_points: PropTypes.number,
            fame_points_bonus: PropTypes.number,
        }).isRequired,
        accountBalance: BalancePropTypes,
        rewards: PropTypes.arrayOf(RewardPropTypes),
        rewardsMeta: RewardsMetaPropTypes,
        eventName: PropTypes.string.isRequired,
        globalMapUrl: PropTypes.string.isRequired,
        signInTokenUrl: PropTypes.string.isRequired,
        realm: PropTypes.string.isRequired,
        globalMapStylesInInventory: PropTypes.arrayOf(PropTypes.number).isRequired,

        close: PropTypes.func.isRequired,
        setShopInnerPageState: PropTypes.func.isRequired,
        onComponentDidMount: PropTypes.func.isRequired,
        onComponentWillUnmount: PropTypes.func.isRequired,
        requestShopGoods: PropTypes.func.isRequired,
        requestRewards: PropTypes.func.isRequired,
        purchaseItem: PropTypes.func.isRequired,
        makeRewardAuctionBet: PropTypes.func.isRequired,
        cancelRewardAuctionBet: PropTypes.func.isRequired,
        playExitClansWinnerRewardSound: PropTypes.func.isRequired,
        playEnterClansWinnerRewardSound: PropTypes.func.isRequired,
        isAddToComparisonAvailable: PropTypes.bool.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            selectedProduct: null,
            currentProduct: null,
            selectedRewardId: null,
            currentRewardId: null,
        }
    }

    componentDidMount() {
        this.props.playEnterClansWinnerRewardSound()
        window.onBeforeUnloadHandlers.playShopSoundsOnExit = () => {
            this.props.playExitClansWinnerRewardSound()
        }
        this.props.onComponentDidMount()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.partitionType !== this.props.partitionType) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                selectedProduct: null,
                currentProduct: null,
                selectedRewardId: null,
                currentRewardId: null,
            })
        }
        if (this.state.currentProduct) {
            this.scrollToCurrentBox(this.state.currentProduct)
        }
        if (this.state.currentRewardId) {
            this.scrollToCurrentBox(this.state.currentRewardId)
        }
    }

    componentWillUnmount() {
        this.props.playExitClansWinnerRewardSound()
        delete window.onBeforeUnloadHandlers.playShopSoundsOnExit
        this.props.onComponentWillUnmount()
    }

    scrollToCurrentBox = (id) => {
        const productElement = document.getElementById(id)
        productElement && productElement.scrollIntoView()
    }

    onErrorClose = (isUnknownError, isWGMoneyError) => {
        const { selectedProduct, selectedRewardId } = this.state
        const {
            error,
            productsErrorActionType,
            rewardsErrorActionType,
            requestShopGoods,
            requestRewards,
            close,
        } = this.props

        const errorActionType = (productsErrorActionType || rewardsErrorActionType)
        const isRequestAction = (errorActionType === ERROR_ACTION_TYPES.REQUEST_ITEMS)
        const isPurchaseAction = (errorActionType === ERROR_ACTION_TYPES.PURCHASE_ITEM)

        const closingShopErrors = new Set([
            ERROR_CODES.REWARDING_IS_FINISHED,
            ERROR_CODES.AUCTION_IS_DISABLED,
        ])
        const closingInfoErrors = new Set([
            ERROR_CODES.ITEM_IS_NOT_AVAILABLE,
            ERROR_CODES.TURN_CALCULATION_IN_PROGRESS,
        ])
        // redirect to clan landing for unhandled errors while loading page and if shop is disabled
        if (
            closingShopErrors.has(error) ||
            (isRequestAction && isUnknownError)
        ) {
            close()
            return
        }

        // open main page if selected product or reward is no longer available or wg Money is unavailable
        if (closingInfoErrors.has(error) ||
           (isPurchaseAction && isUnknownError) ||
            isWGMoneyError
        ) {
            this.openMain()
        }

        if (selectedProduct) {
            requestShopGoods()
        }

        if (selectedRewardId) {
            requestRewards()
        }
    }

    selectProduct = productType => {
        this.props.setShopInnerPageState(true)
        this.setState({
            currentProduct: productType,
            selectedProduct: productType,
        })
    }

    selectReward = rewardId => {
        this.props.setShopInnerPageState(true)
        this.setState({
            currentRewardId: `reward-pack-${rewardId}`,
            selectedRewardId: rewardId,
        })
    }

    backToRewardsScreen = () => {
        this.props.setShopInnerPageState(false)
        this.setState({ selectedRewardId: null })
    }

    openMain = () => {
        const { partitionType } = this.props
        const isProductsPartition = (partitionType === PARTITION_TYPES.products)

        if (isProductsPartition) {
            this.props.setShopInnerPageState(false)
            this.setState({ selectedProduct: null })
        } else {
            this.backToRewardsScreen()
        }
    }

    renderProductsPartition = () => {
        const { products, rewards } = this.props

        const containerClassNames = classNames(
            styles.base,
            this.state.selectedProduct && styles.base__overlayOpened
        )

        return (
            <div className={containerClassNames}>
                {
                    this.state.selectedProduct === null &&
                    <WGCWXShopProducts
                        products={products}
                        accountInfo={this.props.accountInfo}
                        accountBalance={this.props.accountBalance}
                        rewards={rewards}
                        rewardsMeta={this.props.rewardsMeta}
                        eventName={this.props.eventName}
                        globalMapUrl={this.props.globalMapUrl}
                        signInTokenUrl={this.props.signInTokenUrl}
                        selectProduct={this.selectProduct}
                    />
                }
                {
                    this.state.selectedProduct !== null &&
                    <WGCWXShopDetailedProduct
                        realm={this.props.realm}
                        product={products[this.state.selectedProduct]}
                        tankProduct={rewards}
                        productType={this.state.selectedProduct}
                        accountFamePoints={this.props.accountInfo.fame_points}
                        purchaseItem={this.props.purchaseItem}
                        close={this.openMain}
                        globalMapStylesInInventory={this.props.globalMapStylesInInventory}
                    />
                }
            </div>
        )
    }

    renderRewardsPartition = () => {
        const {
            rewards,
            rewardsMeta,
            isAddToComparisonAvailable,
            purchaseItem,
            makeRewardAuctionBet,
            cancelRewardAuctionBet,
            accountBalance,
        } = this.props
        const { selectedRewardId } = this.state
        const selectedTank = rewards.filter(reward =>
            (reward.id === selectedRewardId && reward.type === REWARDS_TYPES.TANK)
        )
        const anyTankSelected = rewards
                                        .filter(item => item.type === REWARDS_TYPES.TANK)
                                        .some(item => item.isSelected)

        return (
            <div className={styles.base}>
                {
                    selectedRewardId === null &&
                    rewards &&
                    <WGCWXRewards
                        rewards={rewards}
                        rewardsMeta={rewardsMeta}
                        accountBalance={accountBalance}
                        selectReward={this.selectReward}
                        isAddToComparisonAvailable={isAddToComparisonAvailable}
                    />
                }
                {
                    selectedRewardId &&
                    <WGCWXRewardsTank
                        wgMoneyServiceError={!accountBalance.isWGMoneyAvailable}
                        accountBalance={accountBalance}
                        selectedTank={selectedTank}
                        rewardsMeta={rewardsMeta}
                        backToRewardsHandler={this.backToRewardsScreen}
                        purchaseItem={purchaseItem}
                        makeRewardAuctionBet={makeRewardAuctionBet}
                        cancelRewardAuctionBet={cancelRewardAuctionBet}
                        isAddToComparisonAvailable={isAddToComparisonAvailable}
                        anyTankSelected={anyTankSelected}
                    />
                }
            </div>
        )
    }

    renderShopError(errorActionType, isWGMoneyError) {
        let { error, partitionType } = this.props

        const erroredPartition = partitionType.toUpperCase()

        const isRewardsPartition = (partitionType === PARTITION_TYPES.rewards)
        const isRequestAction = (errorActionType === ERROR_ACTION_TYPES.REQUEST_ITEMS)
        const isPurchaseAction = (errorActionType === ERROR_ACTION_TYPES.PURCHASE_ITEM)

        let title = ERROR_TITLES[errorActionType]
        let description = ERRORS[error]
        let isUnknownError = false

        if (error === ERROR_CODES.ITEM_IS_NOT_AVAILABLE) {
            description = ERRORS[error][erroredPartition]
        }

        if (isRewardsPartition && error === ERROR_CODES.USER_ALREADY_BOUGHT_THIS_PRODUCT) {
            error = ERROR_CODES.TANK_IS_ALREADY_SELECTED
            description = ERRORS[error]
        }

        if (!description || isWGMoneyError) {
            error = `${erroredPartition}_${ERROR_CODES.UNKNOWN_ERROR}`
            description = ERRORS[error]
            isUnknownError = true
        }

        if (isRequestAction || isPurchaseAction) {
            const errorAction = `${erroredPartition}_${errorActionType}`
            title = isRequestAction ? ERROR_TITLES[errorAction][error] : ERROR_TITLES[errorAction]
        }

        const errorClassNames = classNames(styles.base, styles.base__overlayOpened)

        return (
            <div className={errorClassNames}>
                <WGCWXConfirmation
                    messageType="error"
                    title={title}
                    description={description}
                    buttonsOptions={[
                        {
                            caption: AFFIRMATIVE,
                            callback: () => this.onErrorClose(isUnknownError, isWGMoneyError),
                        },
                    ]}
                    onClose={() => this.onErrorClose(isUnknownError, isWGMoneyError)}
                />
            </div>
        )
    }

    render() {
        let {
            loading,
            error,
            productsErrorActionType,
            rewardsErrorActionType,
            partitionType,
            accountBalance: { isWGMoneyAvailable },
        } = this.props

        if (loading && !error) return (
            <div className={styles.processing}>
                <Processing type="local" isVisible />
            </div>
        )

        let errorActionType
        if (
            partitionType === PARTITION_TYPES.products ||
            productsErrorActionType === ERROR_ACTION_TYPES.PURCHASE_ITEM
        ) {
            errorActionType = productsErrorActionType
        } else {
            errorActionType = rewardsErrorActionType
        }

        const isRewardsPartition = (partitionType === PARTITION_TYPES.rewards)
        const wgMoneyErrorActions = new Set([
            ERROR_ACTION_TYPES.PURCHASE_ITEM,
            ERROR_ACTION_TYPES.MAKE_TANK_BET,
            ERROR_ACTION_TYPES.CANCEL_TANK_BET,
        ])

        const isWGMoneyError = (
            (isRewardsPartition && wgMoneyErrorActions.has(errorActionType) && !isWGMoneyAvailable) ||
            error === ERROR_CODES.WG_MONEY_UNAVAILABILE
        )

        if (error && errorActionType || isWGMoneyError) {
            return this.renderShopError(errorActionType, isWGMoneyError)
        }

        return (
            <div>
                {
                    partitionType === PARTITION_TYPES.products &&
                    this.renderProductsPartition()
                }
                {
                    partitionType === PARTITION_TYPES.rewards &&
                    this.renderRewardsPartition()
                }
            </div>
        )
    }
}

export const stateToProps = ({
     globalMap,
     settings,
     wgcwxShopProducts,
     wgcwxShopRewards,
     wgcwxInventoryStyles,
     wgcwxPreloadImages,
     comparisonBasket,
     balance,
}, ownProps) => {
    const { partitionType } = ownProps.params

    const productsLoading = (wgcwxShopProducts.loading || wgcwxShopProducts.goods === null)
    const rewardsLoading = (wgcwxShopRewards.loading || wgcwxShopRewards.data === null)
    const imagesLoading = !wgcwxPreloadImages.imagesLoaded

    const loading = (
        productsLoading ||
        rewardsLoading ||
        wgcwxShopProducts.processing ||
        wgcwxShopRewards.processing ||
        imagesLoading
    )

    const globalMapStylesInInventory = wgcwxInventoryStyles.styles ?
        Array.from(wgcwxInventoryStyles.styles, style => style.id) : []

    return {
        partitionType,
        loading,
        error: wgcwxShopProducts.errorMessage || wgcwxShopRewards.errorMessage,
        productsErrorActionType: wgcwxShopProducts.errorActionType,
        rewardsErrorActionType: wgcwxShopRewards.errorActionType,
        products: wgcwxShopProducts.goods,
        accountInfo: wgcwxShopProducts.accountInfo,
        accountBalance: balance,
        rewards: wgcwxShopRewards.goods,
        rewardsMeta: wgcwxShopRewards.accountInfo,
        isAddToComparisonAvailable: !comparisonBasket.isFull,
        eventName: globalMap.context_id,
        globalMapUrl: settings.globalMapUrl,
        signInTokenUrl: settings.signInTokenUrl,
        realm: settings.realm,
        globalMapStylesInInventory,
    }
}

const dispatchToProps = (dispatch) => ({
    onComponentDidMount: () => {
        dispatch(requestShopGoods())
        dispatch(requestRewards())
        dispatch(requestComparisonStatus())
        dispatch(requestBalance())
        dispatch(requestPreloadImages())

        addWOTClientListener(C2W_EVENT_TYPES.UPDATE_VEHICLE_STATE, dispatch)
        addWOTClientListener(C2W_EVENT_TYPES.UPDATE_COMPARISON_BASKET, dispatch)
        addWOTClientListener(C2W_EVENT_TYPES.UPDATE_BALANCE, dispatch)
        addWOTClientListener(C2W_EVENT_TYPES.WALLET_UPDATE, dispatch)
    },
    onComponentWillUnmount: () => {
        removeWOTClientListener(C2W_EVENT_TYPES.UPDATE_VEHICLE_STATE, dispatch)
        removeWOTClientListener(C2W_EVENT_TYPES.UPDATE_COMPARISON_BASKET, dispatch)
        removeWOTClientListener(C2W_EVENT_TYPES.UPDATE_BALANCE, dispatch)
        removeWOTClientListener(C2W_EVENT_TYPES.WALLET_UPDATE, dispatch)
    },
    close: () => dispatch(push(CLAN_LANDING)),
    setShopInnerPageState: (isInnerPageOpened) => dispatch(setShopInnerPageState(isInnerPageOpened)),
    requestShopGoods: () => dispatch(requestShopGoods()),
    requestRewards: () => dispatch(requestRewards()),
    requestComparisonStatus: () => dispatch(requestComparisonStatus()),
    purchaseItem: (productId) => dispatch(purchaseItem(productId)),
    makeRewardAuctionBet: (bet, productId) => dispatch(makeRewardAuctionBet(bet, productId)),
    cancelRewardAuctionBet: () => dispatch(cancelRewardAuctionBet()),
    playExitClansWinnerRewardSound: () => dispatch(playExitClansWinnerRewardSound()),
    playEnterClansWinnerRewardSound: () => dispatch(playEnterClansWinnerRewardSound()),
})

export default connect(stateToProps, dispatchToProps)(WGCWXShop)



// WEBPACK FOOTER //
// ./containers/WGCWXShop/WGCWXShop.jsx